import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "CertificateCourse";

export const getCertificateCourseApplication = (rrr) =>  {
  return `${baseUrl}/load-certificate-course-application-form?rrr=${rrr}`;
}

export const addAndUpdateCertificateCourseApplication = () =>  `${baseUrl}/add-or-update-certificate-course-application-form`;

export const addAndUpdateCertificateCourseProgramme = () => `${baseUrl}/add-or-update-certificate-course-application-programme`;

export const addAndUpdateCertificateCourseEducation = () => `${baseUrl}/add-or-update-certificate-course-application-education`;

export const addAndUpdateCertficateCourseOlevel = () => `${baseUrl}/add-or-update-certificate-course-application-olevel-details`;

export const getCertificateCourseReport = (filter) => `${baseUrl}/get-certificate-course-application-report?${generateUrlParams(filter)}`;

export const downloadCertificateCourseReport = (filter) => `${baseUrl}/download-certificate-course-application-report?${generateUrlParams(filter)}`;